<template>
    <md-app style="min-height: 100vh;">
        <md-app-toolbar class="md-primary">
            <div class="md-toolbar-section-start">
            <img class="md-title" src="https://contingentsee.ca/img/header-logo.png">
            </div>
            <div class="md-toolbar-section-end">
                <div v-if="isLawyer">
                    Purchased Bids: {{ purchasedBids }}
                </div>
                <md-menu md-size="auto" v-if="loggedIn">
                    <md-button md-menu-trigger class="md-icon-button">
                        <md-icon>more_vert</md-icon>
                    </md-button>

                    <md-menu-content>
                        <md-menu-item
                            @click="clearSignupToken"
                            v-if="notProduction()"
                            >Clear Signup Token</md-menu-item>
                        <md-menu-item
                            @click="showDialog = true"
                            >Logout</md-menu-item>
                    </md-menu-content>
                </md-menu>
            </div>
        </md-app-toolbar>
        <md-app-content>
            <slot name="content"></slot>
            <md-dialog :md-active.sync="showDialog">
                <md-dialog-title>Are you sure you want to log out?</md-dialog-title>

                <md-dialog-actions>
                    <md-button class="md-primary" @click="showDialog = false">Cancel</md-button>
                    <md-button class="md-primary" @click="logOut">Yes</md-button>
                </md-dialog-actions>
            </md-dialog>
        </md-app-content>
    </md-app>
</template>

<script>
import { signupTokenService } from "@/services/signupTokenService";
import * as user from '@/services/userService';
import { mapGetters } from 'vuex'

export default {
    name: 'CSApp',
    data: () => ({
        showDialog: false,
    }),
    computed: {
        loggedIn: () => user.auth(),
        isLawyer: () => user.isLawyer(),
        ...mapGetters([
            'purchasedBids'
        ]),
    },
    methods: {
        clearSignupToken () {
            signupTokenService(this.$storage, this.$http).clear()
        },
        notProduction () {
            return process.env.VUE_APP_ENVIRONMENT.toLowerCase() !== 'production'
        },
        logOut () {
            this.clearSignupToken()
            this.$storage.removeItem('access_token')
            this.$store.commit('resetState', {})
            this.$storage.removeItem('token_exp')
            this.$storage.removeItem('role')
            this.$router.push('/')
        }
    },
    created () {
        this.$http.get(`${process.env.VUE_APP_API_URL}/bids`).then(response => {
            this.$store.commit('setPurchasedBids', response.data.filter(bid => bid.placedAt === null).length)
        }).catch(error => {
            console.log(error)
        })
    }
}
</script>